import { memo } from 'react';
import { useIntl } from 'react-intl';
import { Flex } from '@/ui/Flex/Flex';
import { T } from '@/ui/Text/Text';
import { Position } from '@xyflow/react';
import ActionHandle from '../ActionHandle';
import { ActionCustomCodeNodeType } from '../types';
import BaseNode from '../BaseNode';

export const ActionCustomCodeNode = memo(
  ({
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    data,
    selected,
    disabled,
  }: {
    data: ActionCustomCodeNodeType['data'];
    selected?: boolean;
    disabled?: boolean;
  }) => {
    const intl = useIntl();

    return (
      <BaseNode
        selected={selected ?? false}
        type="action"
        isValid={data.isValid}
        disabled={disabled}
      >
        <Flex direction="column">
          <T h4>
            {intl.formatMessage({
              defaultMessage: 'Custom Code',
              id: 'fQ4nKo',
            })}
          </T>
          <T body2>
            {intl.formatMessage({
              defaultMessage: 'Default',
              id: 'lKv8ex',
            })}
          </T>
          <ActionHandle
            type="target"
            position={Position.Left}
            disabled={disabled}
          />
          <ActionHandle
            type="source"
            position={Position.Right}
            disabled={disabled}
          />
        </Flex>
      </BaseNode>
    );
  },
);
